/**
 * Les stickers qu'un parent peut envoyer à son enfant.
 *
 * Des autocollants dessinés (CheerStickerArt), pas des personnages : un
 * personnage de l'app reste l'avatar de l'enfant, un bravo doit se lire comme
 * un autocollant collé sur sa journée (décision du 2026-10-19). Jamais
 * d'emoji : l'UI n'en porte pas (décision du 2026-07-02), et un emoji rend
 * différemment d'un appareil à l'autre. Les légendes sont neutres en genre
 * (« Bravo ! », pas « Je suis fier de toi ») puisque la base ne sait pas qui
 * envoie.
 *
 * La liste des clés est aussi celle de la contrainte
 * `child_cheers_sticker_check` (migration 20261016110000) : les deux bougent
 * ensemble.
 */
export const CHEER_STICKERS = [
  { key: 'bravo', color: '#FFC83D', deep: '#E39B00' },
  { key: 'trop_fort', color: '#8B5CF6', deep: '#5B34C7' },
  { key: 'youpi', color: '#FF6FA8', deep: '#D63A7A' },
  { key: 'genial', color: '#2EC4B6', deep: '#158F84' },
  { key: 'super_boulot', color: '#FFB020', deep: '#C47A00' },
  { key: 'continue', color: '#4CC26E', deep: '#2B8A47' },
  { key: 'merci', color: '#FF5A5F', deep: '#C9363B' },
  { key: 'calin', color: '#F28DB2', deep: '#C95A86' },
] as const

export type CheerStickerKey = (typeof CHEER_STICKERS)[number]['key']

/** Mot facultatif : court, c'est un mot, pas une lettre. */
export const CHEER_MESSAGE_MAX = 80

export function cheerSticker(key: string | null | undefined) {
  return CHEER_STICKERS.find(s => s.key === key) ?? CHEER_STICKERS[0]
}
